<template>
  <v-container
    class="my-6"
  >
    <v-row
      align="start"
      justify="center"
      class="text-center mb-1"
    >
      <v-col>
        <v-icon x-large>
          today
        </v-icon>
        <h2 class="display-2 my-2">
          Saison {{ $store.state.saisonStore.saison.nr }}
        </h2>
        <p class="body-2 font-weight-black">
          ({{ $store.state.saisonStore.saison.name }})
        </p>
        <p class="title my-4">
          Du spielst {{ $store.state.teamStore.team.wurfzahl }} Wurf in der {{ $store.getters['teamStore/getLiga'] }}
        </p>
      </v-col>
    </v-row>

    <v-expansion-panels dark>
      <v-expansion-panel class="amber darken-4">
        <v-expansion-panel-header class="headline font-weight-medium">
          Andere Liga wählen
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row
            align="stretch"
            justify="space-around"
            class="white"
          >
            <v-col
              cols="12"
              sm="4"
            >
              <v-card dark color="primary darken-2">
                <v-card-title primary-title>
                  <h5 class="headline font-weight-medium">
                    Wurfzahl?
                  </h5>
                </v-card-title>
                <v-divider />
                <v-card-text>
                  <v-radio-group
                    v-model="choosenWurfzahl"
                    @change="loadWurfLigas"
                    row
                    class="subtitle-1"
                  >
                    <v-radio :label="120 +' Wurf'" :value="120" />
                    <v-radio :label="200 +' Wurf'" :value="200" />
                  </v-radio-group>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col
              cols="12"
              sm="4"
            >
              <v-card dark color="primary darken-2">
                <v-card-title primary-title>
                  <h5 class="headline font-weight-medium">
                    Liga?
                  </h5>
                </v-card-title>
                <v-divider />
                <v-card-text class="subtitle-1">
                  <v-select
                    :items="choosenLigaItems"
                    v-model="choosenLiga"
                    label="Liga wählen"
                    single-line
                    item-text="name"
                    item-value="id"
                    return-object
                  />
                </v-card-text>
              </v-card>
            </v-col>
            <v-col
              cols="12"
              sm="4"
            >
              <v-card dark color="primary darken-2">
                <v-card-title primary-title>
                  <h5 class="headline font-weight-medium">
                    Spieltag?
                  </h5>
                </v-card-title>
                <v-divider />
                <v-card-text class="subtitle-1">
                  <v-select
                    :items="choosenSpieltagItems"
                    v-model="choosenSpieltag"
                    label="Spieltag wählen"
                    single-line
                  />
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              class="text-center py-6 white"
            >
              <v-btn
                dark
                large
                color="primary"
                class="mx-auto"
                @click.native.stop="loadSpieltag"
                :loading="$store.state.pageLoading"
              >
                anzeigen <v-icon dark>
                  mdi-calendar-search
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-row
      class="my-6"
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
        id="spieltag"
      >
        <h3 class="display-1 text-center">
          Auswertung <br>
          {{ selectedLiga.wurf }} Wurf - {{ selectedLiga.name }}
        </h3>
      </v-col>
      <v-col
        cols="12"
        sm="10"
      >
        <v-card>
          <div class="white--text primary darken-2 headline text-center py-2">
            <v-btn
              text
              icon
              :disabled="lastGameDay.spieltag < 2"
              @click.native.stop="showGame(lastGameDay.spieltag - 1)"
              :loading="$store.state.pageLoading"
              class="mr-12"
              dark
            >
              <v-icon medium>
                mdi-arrow-left-circle
              </v-icon>
            </v-btn>
            Spieltag: {{ lastGameDay.spieltag }}
            <v-btn
              text
              icon
              :disabled="lastGameDay.spieltag > 21"
              @click.native.stop="showGame(lastGameDay.spieltag + 1)"
              :loading="$store.state.pageLoading"
              class="ml-12"
              dark
            >
              <v-icon medium>
                mdi-arrow-right-circle
              </v-icon>
            </v-btn>
          </div>
          <v-card-text>
            <v-row
              justify="space-around"
              class="text-left"
            >
              <v-col
                cols="8"
                sm="4"
                class="title text-sm-center"
              >
                Heimteam
              </v-col>
              <v-col
                cols="4"
                sm="4"
                class="body-1 text-center"
              >
                Ergebnis
              </v-col>
              <v-col
                cols="8"
                sm="4"
                class="title text-sm-center"
              >
                Auswärtsteam
              </v-col>
              <v-col
                cols="4"
                class="d-sm-none body-1 text-center"
              >
                Ergebnis
              </v-col>
              <v-col cols="12" class="py-0">
                <v-divider />
              </v-col>
            </v-row>

            <v-row
              justify="space-around"
              v-for="(item, index) in lastGameDay.spiele"
              :key="'auswertung_'+index"
              :class="isMyTeam(item.heimteam_id, item.auswteam_id)"
            >
              <v-col
                class="flex-grow-0 order-1 text-sm-center"
              >
                <v-avatar
                  v-show="item.heimteam_image !== ''"
                  size="32px"
                  class="mr-2"
                >
                  <v-img
                    :src="showLogo(item.heimteam_id)"
                    alt=""
                  />
                </v-avatar>
              </v-col>
              <v-col
                cols="6"
                sm="3"
                class="body-1 flex-grow-1 order-2 text-sm-center"
              >
                <i v-if="isSpielfrei(item.heimteam_name)">Spielfrei</i>
                <span v-else>{{ item.heimteam_name }}</span>
              </v-col>
              <v-col
                cols="3"
                sm="1"
                class="py-2 flex-grow-0 text-center body-1 order-3 text-center"
              >
                <span v-if="item.heimteam_ergebnis > item.auswteam_ergebnis">
                  <b>{{ item.heimteam_ergebnis }}</b>
                </span>
                <span v-else>{{ item.heimteam_ergebnis }}</span>
              </v-col>
              <v-col class="d-none d-sm-flex flex-grow-0 order-4">
                :
              </v-col>

              <v-col
                cols="3"
                sm="1"
                class="py-2 flex-grow-0 text-center body-1 order-xs-last order-7 order-sm-5"
              >
                <span v-if="item.heimteam_ergebnis < item.auswteam_ergebnis">
                  <b>{{ item.auswteam_ergebnis }}</b>
                </span>
                <span v-else>{{ item.auswteam_ergebnis }}</span>
              </v-col>

              <v-col
                cols="6"
                sm="3"
                class="body-1 flex-grow-1 text-sm-right order-xs-1 order-6 order-sm-6"
              >
                <i v-if="isSpielfrei(item.auswteam_name)">Spielfrei</i>
                <span v-else>{{ item.auswteam_name }}</span>
              </v-col>
              <v-col
                class="flex-grow-0 order-5 order-sm-7"
              >
                <v-avatar
                  v-show="showLogo(item.auswteam_id) !== false"
                  size="32px"
                  class="ml-2"
                >
                  <v-img
                    :src="showLogo(item.auswteam_id)"
                    alt=""
                  />
                </v-avatar>
              </v-col>
              <v-col
                cols="12"
                class="text-right text-sm-center pt-1 order-8"
              >
                <v-btn
                  v-if="(!(isSpielfrei(item.heimteam_name) && isSpielfrei(item.auswteam_name)) && (item.heimteam_ergebnis > 0 || item.auswteam_ergebnis > 0))"
                  outlined
                  small
                  color="indigo"
                  @click.stop="showSpielbericht(index)"
                >
                  Spielbericht
                  <v-icon right class="ml-1">
                    mdi-file-document-outline
                  </v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12" class="pa-0 mt-1 order-9">
                <v-divider />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row
      justify="center"
      class="my-0"
      v-if="!$store.state.pageLoading"
      id="tabelle"
    >
      <v-col
        cols="12"
        sm="10"
      >
        <v-card>
          <div
            class="white--text primary darken-2 headline text-xs-left pa-2 pl-4"
          >
            <v-icon class="mx-6" large dark>
              mdi-table-large
            </v-icon>
            Aktuelle Tabelle der Liga
          </div>
          <v-card-text>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr class="tablefont">
                    <th>Platz</th>
                    <th class="text-left">
                      Mannschaft
                    </th>
                    <th>Spiele</th>
                    <th>Punkte</th>
                    <th>∅<br>Ergebnis</th>
                    <th>Ausw.<br>Punkte</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in tabelle"
                    :key="'tabelle_'+index"
                    :class="isMyTeam(item.id)"
                  >
                    <td>{{ index+1 }}</td>
                    <td v-if="isSpielfrei(item.name)" coslpan="2">
                      Spielfrei
                    </td>
                    <td v-else class="text-left">
                      <v-avatar
                        v-show="showLogo(item.id) !== false"
                        size="36px"
                        class="mr-2"
                      >
                        <v-img
                          :src="showLogo(item.id)"
                          alt=""
                        />
                      </v-avatar>
                      {{ item.name }}
                    </td>
                    <td>{{ item.spiele }}</td>
                    <td>{{ item.gesamtpunkte }}</td>
                    <td>{{ Math.round(item.gesamtergebnis/item.spiele) }}</td>
                    <td>{{ item.auswpunkte }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row
      class="my-6"
      justify="center"
    >
      <v-col
        cols="12"
        sm="10"
        id="statistik"
      >
        <h3 class="white--text primary darken-2 headline text-xs-left pa-2 pl-4">
          <v-icon class="mx-6" large dark>
            mdi-trophy-award
          </v-icon> Liga-Statistik - Saisonbestleistungen
        </h3>
      </v-col>

      <BestleistungMannschaft
        :bestleistung="heimBestleistung"
        :is-heim="true"
      />

      <BestleistungMannschaft
        :bestleistung="auswBestleistung"
        :is-heim="false"
      />

      <BestleistungEinzel
        :bestleistung="heimBestleistung"
        :is-heim="true"
      />
      <BestleistungEinzel
        :bestleistung="auswBestleistung"
        :is-heim="false"
      />
    </v-row>

    <v-row
      class="my-6"
      justify="center"
    >
      <v-col
        cols="12"
        sm="10"
        id="statistik"
      >
        <h3 class="white--text primary darken-2 headline text-xs-left pa-2 pl-4">
          <v-icon class="mx-6" large dark>
            mdi-trophy-award
          </v-icon> Liga-Statistik - Ligabestleistungen (Lifetime)
        </h3>
      </v-col>

      <BestleistungMannschaft
        :bestleistung="ligaHeimBestleistung"
        :is-heim="true"
      />

      <BestleistungMannschaft
        :bestleistung="ligaAuswBestleistung"
        :is-heim="false"
      />

      <BestleistungEinzel
        :bestleistung="ligaHeimBestleistung"
        :is-heim="true"
      />
      <BestleistungEinzel
        :bestleistung="ligaAuswBestleistung"
        :is-heim="false"
      />
    </v-row>

    <v-speed-dial
      v-model="fab"
      fixed
      :top="top"
      :bottom="bottom"
      :right="right"
      :left="left"
      :direction="direction"
      :open-on-hover="hover"
      :transition="transition"
    >
      <template v-slot:activator>
        <v-btn
          v-model="fab"
          color="blue darken-2"
          dark
          fab
        >
          <v-icon v-if="fab">
            close
          </v-icon>
          <v-icon v-else>
            mdi-crosshairs
          </v-icon>
        </v-btn>
      </template>
      <v-btn
        fab
        dark
        small
        color="red darken-2"
        href="#statistik"
      >
        <v-icon>mdi-trophy-award</v-icon>
      </v-btn>
      <v-btn
        fab
        dark
        small
        color="primary darken-2 "
        href="#tabelle"
      >
        <v-icon>mdi-table-large</v-icon>
      </v-btn>
      <v-btn
        fab
        dark
        small
        color="primary darken-2"
        href="#spieltag"
      >
        <v-icon>mdi-file-document-outline</v-icon>
      </v-btn>
    </v-speed-dial>

    <Spielbericht
      :dialog-heim-team="dialogHeimTeam"
      :dialog-ausw-team="dialogAuswTeam"
    />
  </v-container>
</template>

<script>
import Spielbericht from '../components/Spielbericht'
import BestleistungMannschaft from '../components/BestleistungMannschaft'
import BestleistungEinzel from '../components/BestleistungEinzel'
const R = require('ramda')

export default {
  name: 'Saison',
  metaInfo: {
    title: 'Saison'
  },
  components: {
    Spielbericht,
    BestleistungMannschaft,
    BestleistungEinzel
  },
  data () {
    return {
      direction: 'top',
      fab: false,
      fling: false,
      hover: true,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: 'slide-y-reverse-transition',
      dialog: false,
      dialogHeimTeam: {
        name: '',
        players: [],
        ergebnis: 0,
        id: 0
      },
      dialogAuswTeam: {
        name: '',
        players: [],
        ergebnis: 0,
        id: 0
      },
      dialogHeimIcons: [
        { name: 'kraft', icon: 'mdi-dumbbell' },
        { name: 'motivation', icon: 'mdi-brain' },
        { name: 'technik', icon: 'mdi-webcam' },
        { name: 'kondition', icon: 'mdi-heart-pulse' }
      ],
      dialogAuswIcons: [
        { name: 'kondition', icon: 'mdi-heart-pulse' },
        { name: 'technik', icon: 'mdi-webcam' },
        { name: 'motivation', icon: 'mdi-brain' },
        { name: 'kraft', icon: 'mdi-dumbbell' }
      ],
      showHeimRekordM: false,
      showAuswRekordM: false,
      showHeimRekordE: false,
      showAuswRekordE: false,
      heimBestleistung: {
        user: {
          id: 0
        },
        einzel: {
          user: {
            id: 0
          },
          saison: {
            spieltag: 0
          },
          ergebnis: 0
        },
        saison: {
          spieltag: 0
        }
      },
      auswBestleistung: {
        user: {
          id: 0
        },
        einzel: {
          user: {
            id: 0
          },
          saison: {
            spieltag: 0
          },
          ergebnis: 0
        },
        saison: {
          spieltag: 0
        }
      },
      ligaHeimBestleistung: {
        user: {
          id: 0
        },
        einzel: {
          user: {
            id: 0
          },
          saison: {
            spieltag: 0
          },
          ergebnis: 0
        },
        saison: {
          spieltag: 0
        }
      },
      ligaAuswBestleistung: {
        user: {
          id: 0
        },
        einzel: {
          user: {
            id: 0
          },
          saison: {
            spieltag: 0
          },
          ergebnis: 0
        },
        saison: {
          spieltag: 0
        }
      },
      liga: '', // get from userdata / user store
      spieltag: 0,
      lastGameDay: [],
      isLastGamePokal: false,
      tabelle: [],
      selectedLiga: {},
      choosenLiga: {
        id: this.$store.state.teamStore.team.ligaId,
        name: this.$store.getters['teamStore/getLiga']
      },
      choosenLigaItems: [],
      choosenWurfzahl: this.$store.state.teamStore.team.wurfzahl,
      choosenSpieltag: this.$store.state.saisonStore.saison.spieltag > 0 ? this.$store.state.saisonStore.saison.spieltag : 1, // todo sitch to current matchgameday
      choosenSpieltagItems: []
    }
  },
  mounted: async function () {
    // load first game
    this.loadSpieltag()
    // alle liegen laden
    if (await this.$store.dispatch('saisonStore/loadAllLeagues')) {
      // alle ligen der gewählten wurfart
      this.choosenLigaItems = this.$store.state.saisonStore.ligen[this.choosenWurfzahl]
    }
    // logos laden und in den cache
    await this.$store.dispatch('saisonStore/loadAllLogos')
  },
  methods: {
    checkNil: function (value) {
      return R.isNil(value)
    },
    showSpielbericht: function (index) {
      const game = this.lastGameDay.spiele[index]

      this.dialogHeimTeam.id = game.heimteam_id
      this.dialogAuswTeam.id = game.auswteam_id
      this.dialogHeimTeam.name = game.heimteam_name
      this.dialogAuswTeam.name = game.auswteam_name
      this.dialogHeimTeam.ergebnis = game.heimteam_ergebnis || 0
      this.dialogAuswTeam.ergebnis = game.auswteam_ergebnis || 0
      this.dialogHeimTeam.players = game.heimteam_players
      this.dialogAuswTeam.players = game.auswteam_players

      // comit to store dialog open
      this.$store.commit('saisonStore/SAISON_SET_MODAL_OPEN', true)

      // TODO load managernamen
    },
    showLogo: function (teamId) {
      if (!teamId) return false
      return this.$store.getters['saisonStore/getLogo'](teamId)
    },
    isMyTeam: function (heimteamId, auswteamId) {
      const myId = this.$store.state.managerStore.id
      return (heimteamId === myId || auswteamId === myId) ? 'grey lighten-2 pt-1 mytablefont text-left' : 'pt-1 tablefont text-left'
    },
    setData: function () {
      this.isLastGamePokal = this.$store.state.saisonStore.lastGameDay.isPokal
      this.lastGameDay = this.$store.state.saisonStore.lastGameDay
      this.choosenSpieltag = this.$store.state.saisonStore.lastGameDay.spieltag
      this.selectedLiga = this.$store.state.saisonStore.selectedLiga

      this.tabelle = this.$store.state.saisonStore.tabelle
      this.choosenSpieltagItems = this.$store.state.saisonStore.spieltage
      // is auswertung pokalauswertung, dann zeige diese view
      if (this.isLastGamePokal) {
        // load pokalauswertung
        this.selectedLiga.name = 'Pokalrunde'
        this.spieltag = this.$store.state.saisonStore.lastGameDay.name
      }
      // statistik
      if (!R.isNil(this.$store.state.saisonStore.statistik)) {
        this.heimBestleistung = this.$store.state.saisonStore.statistik.heimBestleistung
        this.auswBestleistung = this.$store.state.saisonStore.statistik.auswBestleistung
      }
      if (!R.isNil(this.$store.state.saisonStore.ligaStatistik)) {
        this.ligaHeimBestleistung = this.$store.state.saisonStore.ligaStatistik.heimBestleistung
        this.ligaAuswBestleistung = this.$store.state.saisonStore.ligaStatistik.auswBestleistung
      }
      this.showHeimRekordM = false
      this.showAuswRekordM = false
      this.showHeimRekordE = false
      this.showAuswRekordE = false
    },
    loadSpieltag: async function () {
      const payload = {
        wurfzahl: this.choosenWurfzahl,
        ligaId: this.choosenLiga.id,
        spieltag: this.choosenSpieltag
      }

      if (await this.$store.dispatch('saisonStore/loadSpieltag', payload)) {
        // set Data for view
        this.setData()
      }
      return false
    },
    loadWurfLigas: function () {
      this.choosenLigaItems = this.$store.state.saisonStore.ligen[this.choosenWurfzahl]
      this.choosenLiga = this.$store.state.saisonStore.ligen[this.choosenWurfzahl][0]
      return false
    },
    isSpielfrei: function (value) {
      // get spielfrei
      return !!((R.isEmpty(value) || R.isNil(value)))
    },
    showGame: async function (spieltag) {
      const payload = {
        wurfzahl: this.selectedLiga.wurf,
        ligaId: this.selectedLiga.id,
        spieltag: spieltag
      }
      if (await this.$store.dispatch('saisonStore/loadSpieltag', payload)) {
        // set Data for view
        this.setData()
      }
      return false
    }
  }
}
</script>

<style scoped>
.tablefont th,.tablefont td {
  font-size: 1rem!important;
}
.mytablefont td {
  font-size: 1.25rem!important;
  font-weight: 500;
}
</style>
